import React from "react";
import {Button, Modal} from "react-bootstrap";
import {useAppDispatch, useAppSelector} from "../../../app/store";
import {ADMIN_LANG} from "../../../settings";
import {DragDropContext, Draggable, Droppable, DropResult} from "@hello-pangea/dnd";
import AdminLoader from ".././AdminLoader";
import {GripVertical} from "react-bootstrap-icons";
import {closeSectionOrderModal} from "../../../app/slices/modals/sectionOrderModal";
import {changeGameDetail, updateSectionOrder} from "../../../app/slices/adminGameView";


const SectionOrderModal = () => {
    const dispatch = useAppDispatch();
    const {isOpen, languageTab} = useAppSelector((state) => state.sectionOrderModal);
    const {version_sections, game_id, current_version_id, loaded} = useAppSelector((state) => state.adminGameView);

    const handleClose = () => {
        dispatch(closeSectionOrderModal());
    }

    const handleDragEnd = (result: DropResult) => {
        if (!result.destination) return;
        const reorderedSections = [...version_sections];
        const [removed] = reorderedSections.splice(result.source.index, 1);
        reorderedSections.splice(result.destination.index, 0, removed);
        dispatch(changeGameDetail({version_sections: reorderedSections}));
        dispatch(updateSectionOrder({
            version_sections: reorderedSections,
            game_id: game_id,
            version_id: current_version_id
        }));
    }

    return (
        <Modal size='xl' show={isOpen} onHide={handleClose} className='admin-modal'>
            {!loaded && <AdminLoader/>}
            <Modal.Header closeButton>
                <Modal.Title>{ADMIN_LANG.edit_order}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="section-order">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className={`section-order-container${snapshot.isDraggingOver ? ' dragging-over' : ''}`}
                            >
                                {version_sections.map((section, index) => {
                                    const selectedLanguage = section.languages.find(lang => lang.language_code === languageTab);
                                    return (
                                        <Draggable key={section.key} draggableId={section.key} index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className={`section-order-wrapper${snapshot.isDragging ? ' dragging' : ''}`}
                                                >
                                            <span className='section-order-text'>
                                                {selectedLanguage ? selectedLanguage.name : ''}
                                            </span>
                                                    <GripVertical className='utility-icon drag-icon'/>
                                                </div>
                                            )}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='outline-primary' onClick={handleClose}>
                    {ADMIN_LANG.close}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SectionOrderModal;